module.exports = __webpack_public_path__ + "static/nationalrestoration-7da6d6fd4e95e2ae43763579ec09f9c4.jpg";